/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';

import {
  UPDATE_GROUP_TYPES,
  SET_GROUP_TYPE,
  DELETE_GROUP_TYPE,
} from './actions';

export function GroupTypes(state = Immutable.Map(), action = { type: null }) {
  switch (action.type) {
    case UPDATE_GROUP_TYPES: {
      const groupTypes = Immutable.fromJS(action.groupTypes);
      let newState = state;
      for (const groupType of groupTypes.values()) {
        newState = newState.set(groupType.get('id'), groupType);
      }
      return newState;
    }
    case SET_GROUP_TYPE: {
      const { groupType } = action;
      return state.set(groupType.get('id'), groupType);
    }
    case DELETE_GROUP_TYPE: {
      const { groupType } = action;
      return state.remove(groupType.get('id'));
    }
    default:
      return state;
  }
}
